import BaseIcon from './BaseIcon';
import React, { ReactElement, SVGProps } from 'react'

export default function FunnelIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M6 12h12M2.25 7.5h19.5m-12 9h4.5"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  )
}
